/* eslint-disable */
export default () =>
  '\
<?xml version="1.0" encoding="utf-8"?>\
<DieCutLabel Version="8.0" Units="twips" MediaType="Default">\
  <PaperOrientation>Landscape</PaperOrientation>\
  <Id>Address</Id>\
  <PaperName>30252 Address</PaperName>\
  <DrawCommands>\
    <RoundRectangle X="0" Y="0" Width="1581" Height="5040" Rx="270" Ry="270"/>\
  </DrawCommands>\
  <ObjectInfo>\
    <BarcodeObject>\
      <Name>Barcode</Name>\
      <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
      <BackColor Alpha="255" Red="255" Green="255" Blue="255"/>\
      <LinkedObjectName></LinkedObjectName>\
      <Rotation>Rotation0</Rotation>\
      <IsMirrored>False</IsMirrored>\
      <IsVariable>False</IsVariable>\
      <Text>2XMU0JM-A</Text>\
      <Type>Code128Auto</Type>\
      <Size>Medium</Size>\
      <TextPosition>Top</TextPosition>\
      <TextFont Family="Helvetica" Size="14" Bold="False" Italic="False" Underline="False" Strikeout="False"/>\
      <CheckSumFont Family="Helvetica" Size="10" Bold="False" Italic="False" Underline="False" Strikeout="False"/>\
      <TextEmbedding>None</TextEmbedding>\
      <ECLevel>0</ECLevel>\
      <HorizontalAlignment>Center</HorizontalAlignment>\
      <QuietZonesPadding Left="0" Right="0" Top="0" Bottom="0"/>\
    </BarcodeObject>\
    <Bounds X="331.9589" Y="153.1803" Width="4495.246" Height="1092.634"/>\
  </ObjectInfo>\
</DieCutLabel>'
